<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-16 09:43:46
 * @LastEditTime : 2020-01-07 18:31:39
 * @LastEditors  : Please set LastEditors
 -->
<template>
    <div id="page_Container">
        <div class="page">
            <div id="main-container" class="main-container orderbody">
                <div class="addrinfo toastClass">
                    <!-- 已选地址 -->
                    <div
                        v-if="
                            requireInfo.defaultAddressFlag === '2' ||
                            requireInfo.flag === '2'
                        "
                        class="addr adddetail"
                        @click="gochoose()"
                    >
                        <div class="consignee">
                            <span class="name">{{
                                requireInfo.defaultAddress.receiver
                            }}</span
                            ><span class="phone">{{
                                requireInfo.defaultAddress.mobileNumber
                            }}</span>
                        </div>
                        <div class="address">
                            <img
                                src="../assets/img/goods/addr.png"
                                alt=""
                            /><span class="addrdetail"
                                >{{ requireInfo.defaultAddress.area
                                }}{{ requireInfo.defaultAddress.address }}</span
                            >
                        </div>
                    </div>
                    <!-- 未选地址-选择地址 -->
                    <div
                        v-if="requireInfo.defaultAddressFlag === '1'"
                        class="addr"
                        @click="gochoose()"
                    >
                        <img src="../assets/img/goods/addr.png" alt="" />
                        <span class="noaddr choose">选择收货地址</span>
                    </div>
                    <!-- 未选地址-新增地址 -->
                    <div
                        v-if="requireInfo.defaultAddressFlag === '0'"
                        class="addr"
                        @click="goadd()"
                    >
                        <img src="../assets/img/goods/addr.png" alt="" />
                        <span class="noaddr add">新增收货地址</span>
                    </div>
                </div>
                <div class="afteraddrpng">
                    <img src="../assets/img/goods/afteraddr.png" alt="" />
                </div>
                <div
                    v-for="(item, index) in orderRespDTOList"
                    :key="index"
                    class="productStyle"
                >
                    <p class="title">
                        <img :src="zt" alt="" v-if="item.label === '自营'" />
                        <img :src="kd" alt="" v-else />

                        <span>{{ item.label }}</span>
                    </p>
                    <div class="ordergoods">
                        <div
                            class="goods"
                            v-for="good in item.value.memberOrderItemList"
                            :key="good.id"
                        >
                            <div class="goods-img">
                                <img :src="good.productImg" alt="" />
                            </div>
                            <div class="goods-detail">
                                <p class="goodstitle">{{ good.productName }}</p>
                                <p class="specifications">
                                    {{ good.specificationValue }}
                                </p>
                                <p class="goodsprice">
                                    ¥<span>{{
                                        ESVBase.numberTofixed(good.productPrice)
                                    }}</span
                                    ><span class="num"
                                        >×{{ good.quantity }}</span
                                    >
                                </p>
                            </div>
                        </div>
                    </div>
                    <van-cell-group :border="false">
                        <van-cell
                            title="是否自提"
                            :value="item.value.isPickupStr"
                            v-show="item.value.pickupShow"
                            :border="false"
                            value-class="spanStyleRight"
                            is-link
                            @click="pickupClick(item, index)"
                        />
                        <van-cell
                            title="配送方式"
                            :value="item.value.deliveryMethodStr"
                            :border="false"
                            value-class="spanStyleRight"
                        />
                        <van-cell
                            v-if="!showReferralFeature"
                            v-show="item.value.outletShow"
                            title="选择网点"
                            :value="item.value.outletName"
                            :border="false"
                            value-class="spanStyleRight"
                            is-link
                            @click="choiceDot(item, index)"
                        />
                        <van-cell
                            title="物流运费"
                            :value="`¥${item.value.freightAmount.toFixed(2)}`"
                            :border="false"
                            value-class="spanStyleRight"
                        />
                        <van-cell
                            title="套装优惠"
                            :value="`- ¥${item.value.groupBenefitAmount.toFixed(
                                2
                            )}`"
                            :border="false"
                            value-class="spanStyleRight"
                            v-show="genericCouponShow"
                        />
                        <van-cell
                            title="活动优惠"
                            :value="getActivity(item.value)"
                            :border="false"
                            value-class="spanStyleRight"
                            v-if="item.value.activityId !== '-1'"
                        />
                        <van-field
                            v-model="item.value.remark"
                            label="订单备注："
                            type="textarea"
                            placeholder="选填：填写内容已和卖家协商确认"
                            rows="1"
                            autosize
                            input-align="right"
                            @focus="msgfocus()"
                            @blur="msgblur()"
                        />
                    </van-cell-group>
                    <div
                        class="require distribution"
                        v-if="
                            item.value.activeList &&
                            item.value.activeList.length > 0
                        "
                    >
                        <div>
                            <van-popup
                                v-model="fullshow"
                                position="bottom"
                                :overlay="true"
                            >
                                <div class="attrsNew">
                                    <van-radio-group v-model="fullIdNew">
                                        <van-cell-group>
                                            <div
                                                v-for="active in activeList"
                                                :key="active.activityId"
                                            >
                                                <van-cell
                                                    v-if="
                                                        active.activityType ===
                                                        2
                                                    "
                                                    :title="
                                                        '满' +
                                                        active.meet +
                                                        '件减' +
                                                        active.preferentialAmount +
                                                        '元'
                                                    "
                                                    clickable
                                                    @click="
                                                        clickRadio(
                                                            active,
                                                            item,
                                                            active.aindex
                                                        )
                                                    "
                                                >
                                                    <div class="divRight"></div>
                                                    <van-radio
                                                        :name="
                                                            active.activityId
                                                        "
                                                    />
                                                </van-cell>
                                                <van-cell
                                                    v-if="
                                                        active.activityType ===
                                                        3
                                                    "
                                                    :title="
                                                        '满' +
                                                        active.meet +
                                                        '件打' +
                                                        Number(
                                                            active.preferentialAmount
                                                        ) /
                                                            10 +
                                                        '折'
                                                    "
                                                    clickable
                                                    @click="
                                                        clickRadio(
                                                            active,
                                                            item,
                                                            active.aindex
                                                        )
                                                    "
                                                >
                                                    <div class="divRight"></div>
                                                    <van-radio
                                                        :name="
                                                            active.activityId
                                                        "
                                                    />
                                                </van-cell>
                                                <van-cell
                                                    v-if="
                                                        active.activityType ===
                                                        4
                                                    "
                                                    :title="
                                                        active.activityTitle
                                                    "
                                                    clickable
                                                    @click="
                                                        clickRadio(
                                                            active,
                                                            item,
                                                            active.aindex
                                                        )
                                                    "
                                                >
                                                    <div class="divRight"></div>
                                                    <van-radio
                                                        :name="
                                                            active.activityId
                                                        "
                                                    />
                                                </van-cell>
                                            </div>
                                        </van-cell-group>
                                    </van-radio-group>
                                </div>
                                <div
                                    class="clickoff"
                                    @click.stop="closeFullShow()"
                                >
                                    关闭
                                </div>
                            </van-popup>
                        </div>
                    </div>
                    <div class="js">
                        共{{ item.value.quantity }}件，小计：<span
                            >¥{{ item.value.orderPayAmount.toFixed(2) }}</span
                        >
                    </div>
                </div>
                <div v-if="showReferralFeature" class="productStyle">
                    <van-cell
                        title="选择门店"
                        :value="referralOutlet"
                        :border="false"
                        value-class="spanStyleRight"
                        is-link
                        @click="choiceReferralOutlet"
                    />
                    <van-cell-group :border="false">
                        <van-field
                            v-model="referralCode"
                            label="推荐码："
                            type="textarea"
                            placeholder="请输入推荐码"
                            rows="1"
                            autosize
                            input-align="right"
                        />
                    </van-cell-group>
                </div>
                <div
                    class="require distribution"
                    @click="showActivity()"
                    v-if="
                        requireInfoall.couponList &&
                        requireInfoall.couponList.length >= 1
                    "
                >
                    <div class="choose">
                        <span class="yhStyle">优惠券</span
                        ><span class="f-right">{{
                            couponSimpleName || couponName
                        }}</span>
                    </div>
                </div>
                <div>
                    <van-cell-group>
                        <van-cell
                            :title="genericCoupon"
                            is-link
                            arrow-direction="down"
                            @click="showGenericCouponPicker = true"
                            v-show="
                                requireInfoall.genericCouponList &&
                                requireInfoall.genericCouponList.length > 1
                            "
                        />
                        <van-cell
                            title=""
                            @click="cellClickCheck"
                            class="checkBox"
                            v-if="requireInfoall.usePoint > 0"
                        >
                            <template slot="title">
                                <span class="custom-title"
                                    >可用{{ requireInfoall.usePoint }}积分抵扣{{
                                        requireInfoall.allDeductionAmount
                                    }}元</span
                                >
                            </template>
                            <van-checkbox
                                v-model="checked"
                                class="checkBoxStyle"
                                @change="changeChecked"
                            ></van-checkbox>
                            <div class="checkBoxDiv"></div>
                        </van-cell>
                    </van-cell-group>
                </div>
                <div class="require distribution">
                    <van-popup
                        v-model="showstyleActivity"
                        position="bottom"
                        :overlay="true"
                    >
                        <div class="paratitle">优惠详情</div>
                        <div class="attrs">
                            <van-radio-group v-model="radioActivity">
                                <van-cell-group>
                                    <van-cell
                                        :title="
                                            item.couponSimpleName ||
                                            item.couponName
                                        "
                                        v-for="item in requireInfoall.couponList"
                                        :key="item.id"
                                        clickable
                                        @click="activityClick(item)"
                                        :label="
                                            item.couponValidityStart
                                                ? item.couponValidityStart +
                                                  '-' +
                                                  item.couponValidityEnd
                                                : ''
                                        "
                                    >
                                        <div class="divRight"></div>
                                        <van-radio :name="item.couponCode" />
                                    </van-cell>
                                </van-cell-group>
                            </van-radio-group>
                        </div>
                        <div
                            class="clickoff"
                            @click.stop="clickoffbtnActivity()"
                        >
                            确定
                        </div>
                    </van-popup>
                </div>
                <div class="placehholder"></div>
            </div>
            <div v-show="submitShow" class="bottomtab">
                <op-submit-bar
                    :num="allTotalNum"
                    @submit="onSubmit()"
                    :price="
                        requireInfoall.sumPayAmount >= 0
                            ? requireInfoall.sumPayAmount
                            : 0
                    "
                    button-text="提交订单"
                ></op-submit-bar>
            </div>
            <van-popup v-model="showGenericCouponPicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="requireInfoall.genericCouponList"
                    @confirm="genericCouponConfirm"
                    :default-index="0"
                    value-key="couponShowName"
                    @cancel="showGenericCouponPicker = false"
                />
            </van-popup>
            <!-- 是否自提 -->
            <van-popup v-model="showPickupPicker" position="bottom">
                <van-picker
                    show-toolbar
                    ref="pickupPicker"
                    :columns="['是', '否']"
                    @confirm="pickupConfirm"
                    :default-index="pickupDefaultIndex"
                    @cancel="showPickupPicker = false"
                />
            </van-popup>
            <!-- 网点列表 -->
            <van-popup v-model="showCOPicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="outletList"
                    @confirm="setReferralOutlet"
                    :default-index="referralOutletDefaultIndex"
                    value-key="outletName"
                    @cancel="showCOPicker = false"
                />
            </van-popup>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
import { mapMutations, mapGetters } from 'vuex';
export default {
    name: 'confirmOrder',
    data () {
        return {
            init: true,
            pickupDefaultIndex: 1,
            referralOutlet: '',
            referralCode: '',
            referralOutletDefaultIndex: 0,
            genericCoupon: '',
            // 选择的商品的index
            checkedGoodsIndex: 0,
            outletList: [],
            showPickupPicker: false,
            showCOPicker: false,
            // showOutletListPicker: false,
            genericCouponCode: -1,
            showGenericCouponPicker: false,
            checked: true,
            fullIdNew: null,
            activeList: [],
            fullId: '',
            fullText: '',
            radio: '1',
            fullshow: false,
            goodsInfo: {},
            skuData: {},
            requireInfo: {},
            requireInfoall: {},
            orderRespDTOList: [],
            orderItemList: [],
            orderList: [],
            showstyleActivity: false,
            showstyleCoupons: false,
            couponCode: '',
            radioCouponsName: '请选择',
            radioActivity: '-1',
            deliveryMethodId: '',
            deliveryMethodIdNew: null,
            message: '',
            focus: false,
            orderJsonList: [],
            submitType: '',
            bodyheight: 0,
            useCouponFlag: '', // 是否可使用优惠券
            activeDiscountAmount: '', // 活动优惠金额

            couponList: [], // 优惠券列表
            participate: '',
            choosecoupon: '',
            ps: require('../assets/img/myCenter/ps.png'),
            kd: require('../assets/img/myCenter/kd.png'),
            zt: require('../assets/img/myCenter/zt.png'),
            zy: require('../assets/img/myCenter/zy.png'),
            arr: [],
            couponName: '不使用优惠券',
            objCoupon: {},
            usePointFlag: '1',
            fullArr: [],
            allTotalNum: 0, // 总共数量
            merchantCode: ''
        };
    },
    esvReady () {
        this.ESVStorage.putSavedValue('usePointFlag', '1');
    },
    esvShow () {
        const ths = this;
        ths.allTotalNum = 0;
        document.title = '确认订单';
        this.ESVStorage.getSavedValue('submitType', (data) => {
            ths.submitType = data;
        });
        this.ESVStorage.getSavedValue('requireInfo', (data) => {
            ths.requireInfo = data;
        });

        this.ESVStorage.getSavedValue('requireInfoall', (data) => {
            console.log('requireInfoall', data);
            ths.requireInfoall = data;

            this.setGenericCouponList(data);
            if (this.requireInfoall.genericCouponList && this.requireInfoall.genericCouponList.length > 1) {
                this.genericCoupon = this.requireInfoall.genericCouponList[0].couponShowName;
            } else {
                this.genericCoupon = this.requireInfoall.genericCouponList[0].couponShowName;
            }
            ths.orderRespDTOList = [];
            ths.orderRespDTOList = ths.requireInfoall.orderRespDTOList;
            ths.orderRespDTOList.forEach((itemNew, index) => {
                if (this.init) {
                    // 关联数据初始化
                    this.initGoodsCommitData(itemNew);
                    // 初始化物流展示数据
                    this.showLogisticsType(itemNew);
                } else {
                    // itemNew.value = { ...itemNew.value, ...this.deliveryArr[index] };
                }

                if (itemNew.value.memberOrderItemList.length > 0) {
                    let res = 0;
                    itemNew.value.memberOrderItemList.forEach((list) => {
                        res += parseInt(list.quantity);
                    });
                    itemNew.value.totalNum = res;
                    ths.allTotalNum += itemNew.value.totalNum;
                }
                // 赋值活动
                // let fullArr;
                // let fullArrText;
                ths.ESVStorage.getSavedValue('fullArr', (data) => {
                    ths.fullArr = data;
                    if (ths.fullArr) {
                        itemNew.value.fullId = ths.fullArr[index];
                    }
                });
                ths.ESVStorage.getSavedValue('fullArrText', (data) => {
                    console.log('fullArrText', data);
                    ths.fullArrText = data;
                    if (ths.fullArrText) {
                        itemNew.value.fullText = ths.fullArrText[index];
                        // console.log(itemNew.value.fullText);
                    }
                });
                ths.ESVStorage.getSavedValue('invoiceArr', (data) => {
                    console.log('invoiceArr', data);

                    ths.arr = data;
                    itemNew.invoice = ths.arr[index];
                });
            });
            this.init = false;
            ths.couponList = ths.requireInfoall.couponList;
            if (ths.couponList && ths.couponList.length > 0) {
                if (this.couponList[this.couponList.length - 1].couponCode !== '-1') {
                    this.couponList.push({
                        couponName: '不使用优惠券',
                        couponCode: '-1'
                    });
                }
            }
            ths.orderItemList = ths.requireInfoall.orderItemList;
            ths.useCouponFlag = ths.requireInfoall.useCouponFlag ? ths.requireInfoall.useCouponFlag : '2';
            ths.activeDiscountAmount = ths.requireInfoall.activeDiscountAmount;
        });
        const arr = [];
        const arrText = [];
        this.orderRespDTOList && this.orderRespDTOList.forEach((item, index) => {
            item.value.remark = '';
            if (item.value.activeList && item.value.activeList.length > 0) {
                if (item.value.activeList[0].activityType === 2) {
                    item.value.fullText = '满' + item.value.activeList[0].meet + '件减' + item.value.activeList[0].preferentialAmount + '元';
                }
                if (item.value.activeList[0].activityType === 3) {
                    item.value.fullText = '满' + item.value.activeList[0].meet + '件打' + Number(item.value.activeList[0].preferentialAmount) / 10 + '折';
                }
                item.value.fullId = item.value.activeList[0].activityId;
                this.fullArr[index] ? arr[index] = this.fullArr[index] : arr[index] = item.value.fullId;
                this.fullArrText[index] ? arrText[index] = this.fullArrText[index] : arrText[index] = item.value.fullText;
            }
            ths.ESVStorage.putSavedValue('fullArr', arr);
            ths.ESVStorage.putSavedValue('fullArrText', arrText);
            // 给发票信息赋值
            item.invoice = this.arr[index];

            let remarkArr;
            ths.ESVStorage.getSavedValue('remarkArr', (data) => {
                remarkArr = data;
                if (remarkArr) {
                    item.value.remark = remarkArr[index].remark;
                }
            });
            if (this.fullArr) {
                item.value.fullId = this.fullArr[index];
            }
            if (this.fullArrText) {
                item.value.fullText = this.fullArrText[index];
            }
        });
        // 赋值积分
        if (this.ESVStorage.getSavedValue('usePointFlag') && this.ESVStorage.getSavedValue('usePointFlag') === '1') {
            this.usePointFlag = '1';
            this.checked = true;
        } else {
            this.usePointFlag = '2';
            this.checked = false;
        }

        this.orderItemList = this.requireInfoall.orderItemList;
        this.useCouponFlag = this.requireInfoall.useCouponFlag ? this.requireInfoall.useCouponFlag : '2';
        this.activeDiscountAmount = this.requireInfoall.activeDiscountAmount;
        this.submitType = this.submitType;
        this.bodyheight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        this.ESVStorage.getSavedValue('objCoupon', (data) => {
            ths.objCoupon = data !== '' ? data : {};
            if (this.couponList) {
                for (var i = 0; i < this.couponList.length; i++) {
                    if (this.couponList[i].couponCode === this.objCoupon.couponCode) {
                        this.radioActivity = this.objCoupon.couponCode;
                        this.couponName = this.objCoupon.couponName;
                        this.couponSimpleName = this.objCoupon.couponSimpleName;
                        return false;
                    } else {
                        this.radioActivity = '-1';
                        this.couponName = '不使用优惠券';
                    }
                }
            }
        });
        this.ESVStorage.getSessionValue('baseSession', (data) => {
            const { merchantCode } = { ...data };

            if (merchantCode) {
                this.merchantCode = merchantCode;
            } else {
                this.$doRequest(
                    { url: '/merchant/getMerchantInfo', params: {} },
                    (data) => {
                        const merchantCode = data.result.merchantCode;
                        const url = window.location.href.split('#')[0] + '#/OPHomenew';
                        const title = data.result.wechantTitle;

                        this.$doRequest(
                            {
                                url: '/oauth/getShortOauthUrl',
                                params: {
                                    url,
                                    merchantCode
                                }
                            },
                            (data) => {
                                this.link = data.result;
                                console.log('merchantCode link', this.link);
                                const baseSession = {
                                    merchantCode: merchantCode,
                                    link: this.link,
                                    wechatTitle: title
                                };
                                this.ESVStorage.putSessionValue('baseSession', baseSession);
                                this.merchantCode = merchantCode;
                            },
                            () => { }
                        );
                    },
                    function () { }
                );
            }
        });
    },
    methods: {
        ...mapMutations(['setDeliveryArr']),
        pickupClick (item, index) {
            console.log(item);
            this.showPickupPicker = true;
            this.checkedGoodsIndex = index;
            this.pickupDefaultIndex = item.value.isPickup;
        },
        choiceDot (item, index) {
            if (this.requireInfo.defaultAddressFlag === '0') {
                Toast('请新增收货地址');
                return false;
            }
            if (this.requireInfo.defaultAddressFlag === '1') {
                Toast('请选择收货地址');
                return false;
            }
            this.ESVStorage.putSavedValue('requireInfoall', this.requireInfoall);
            this.esvOpenPage({
                name: 'OPChoiceDot',
                params: {
                    choiceIndex: index,
                    productGroupId:
          this.$route.params.productGroupId,
                    genericCouponCode: this.genericCouponCode
                }
            });
        },
        async choiceReferralOutlet (item, index) {
            if (this.requireInfo.defaultAddressFlag === '0') {
                Toast('请新增收货地址');
                return false;
            }
            if (this.requireInfo.defaultAddressFlag === '1') {
                Toast('请选择收货地址');
                return false;
            }
            if (!this.outletList.length) await this.queryOutletOffline();
            this.showCOPicker = true;
            this.checkedGoodsIndex = index;
        },
        setReferralOutlet (value, index) {
            this.showCOPicker = false;
            console.info(value);
            this.referralOutlet = value.outletName;
            this.referralOutletId = value.id;
            this.referralOutletDefaultIndex = index;
        },
        initGoodsCommitData (item) {
            item.value = {
                ...item.value,
                isPickupStr: '否',
                isPickup: 1,
                pickupShow: false,
                outletShow: false
            };
        },
        showLogisticsType (data) {
            const logisticsTypeList = data.value.logisticsTypeList;
            // 数据处理
            if (Object.keys(logisticsTypeList).length === 1) {
                data.value.pickupShow = false;

                // 配送方式显示
                for (const k in logisticsTypeList) {
                    if (logisticsTypeList.hasOwnProperty(k)) {
                        const item = logisticsTypeList[k];
                        data.value.outletShow = k === 'COME_ON';
                        data.value.deliveryMethodStr = item;
                        data.value.deliveryMethodCode = k;
                    }
                }
            }
            if (Object.keys(logisticsTypeList).length > 1) {
                data.value.pickupShow = false;
                data.value.outletShow = false;

                // 配送方式显示
                // 存在自提
                // 默认不选择自提
                if (logisticsTypeList.hasOwnProperty('COME_ON')) {
                    data.value.pickupShow = true;
                }
                // 判断是否有快递
                if (logisticsTypeList.hasOwnProperty('EXPRESS_DELIVERY')) {
                    data.value.deliveryMethodStr = logisticsTypeList['EXPRESS_DELIVERY'];
                    data.value.deliveryMethodCode = 'EXPRESS_DELIVERY';
                } else {
                    data.value.deliveryMethodStr = logisticsTypeList['EXPRESS_DISTRIBUTION'];
                    data.value.deliveryMethodCode = 'EXPRESS_DISTRIBUTION';
                }
            }
            // 存在自提 可选择网点

            // 如果存在自提且存在其他方式，则可以选择是否自提
            // 快递配送 显示配送
            // 配送方式显示
        },
        pickupConfirm (value, index) {
            const orderRespDTOList = this.orderRespDTOList;
            const item = orderRespDTOList[this.checkedGoodsIndex].value;
            const logisticsTypeList = item.logisticsTypeList;
            item.isPickupStr = value;
            item.isPickup = index;
            if (!index) {
                item.deliveryMethodCode = 'COME_ON';
                item.deliveryMethodStr = logisticsTypeList[item.deliveryMethodCode];
            } else {
                this.showLogisticsType(orderRespDTOList[this.checkedGoodsIndex]);
            }

            item.outletShow = !index;
            this.showPickupPicker = false;
            this.markData();
            this.confirmOrderNew(this.requireInfo);
            this.pickupDefaultIndex = index;
        },

        genericCouponConfirm (value, index) {
            this.genericCoupon = value.couponShowName;
            this.genericCouponCode = value.couponCode;
            // this.checked = false;
            this.showGenericCouponPicker = false;
            this.markData();
            this.confirmOrderNew(this.requireInfo);
        },
        setGenericCouponList (data) {
            console.log('setGenericCouponList', data);

            this.requireInfoall.genericCouponList = data.genericCouponList || [];
            if (!this.requireInfoall.genericCouponList[0] || this.requireInfoall.genericCouponList[0].couponCode !== -1) {
                console.log('add');

                this.requireInfoall.genericCouponList.unshift({
                    couponShowName: '不使用优惠券',
                    couponCode: -1
                });
            }
        },
        // 根据id显示活动
        getActivity (item) {
            console.log(item);
            if (item.activityId === '-1') {
                return '-';
            } else {
                if (typeof item.activeList === 'string') {
                    item.activeList = JSON.parse(item.activeList);
                    console.log(item.activeList);
                }
                const list = item.activeList;
                // console.log(list);

                for (let i = 0; i < list.length; i++) {
                    const element = list[i];
                    if (element.id === item.activityId) {
                        console.log('优惠');
                        console.log(element);
                        return '省' + item.activityPreferentialAmount + '元:' + element.activityTitle;
                    }
                }
            }
        },
        gochoose () {
            const ths = this;
            const remarkArr = [];
            this.orderRespDTOList.forEach((item, index) => {
                remarkArr.push({
                    remark: item.value.remark
                });
            });
            this.markData();
            this.ESVStorage.putSavedValue('requireInfoall', this.requireInfoall);
            this.ESVStorage.putSavedValue('remarkArr', remarkArr, () => {
                ths.esvOpenPage({ name: 'OPChoiceAddress', params: { productGroupId: this.$route.params.productGroupId, genericCouponCode: this.genericCouponCode } });
            });
        },
        goadd () {
            const ths = this;
            const remarkArr = [];
            this.orderRespDTOList.forEach((item, index) => {
                remarkArr.push({
                    remark: item.value.remark
                });
            });
            this.ESVStorage.putSavedValue('requireInfoall', this.requireInfoall);
            this.ESVStorage.putSavedValue('remarkArr', remarkArr, () => {
                ths.esvOpenPage('OPAddAddress');
            });
        },
        /* 优惠活动 */
        showActivity () {
            this.showstyleActivity = true;
        },
        clickoffbtnActivity () {
            this.showstyleActivity = false;
        },
        /* 选择优惠券 */
        showCoupons () {
            this.showstyleCoupons = true;
        },
        clickoffbtnCoupons () {
            this.showstyleCoupons = false;
        },
        toCouponsRules () {
            this.esvOpenPage('OPCouponsRules');
        },
        /* 买家留言获取输入框焦点 */
        msgfocus () {
            const self = this;
            this.focus = true;
            this.getPayResultInterval = setInterval(function () {
                self.bodyheight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            }, 1000);
        },
        /* 买家留言取消输入框焦点 */
        msgblur () {
            this.focus = false;
            clearInterval(this.getPayResultInterval);
        },
        queryOutletOffline () {
            this.$doRequest({
                url: '/outlet/queryOutletOffline',
                params: {},
                before: () => {
                    this.loading = toastLoading();
                },
                complete: () => {
                    clearToastLoading(this.loading);
                }
            },
            (data) => {
                this.outletList = data.result;
            });
        },
        /* 提交订单 */
        onSubmit () {
            const ths = this;
            try {
                ths.markData('submit');
            } catch (error) {
                return false;
            }

            if (ths.requireInfo.defaultAddressFlag === '0') {
                Toast('请新增收货地址');
                return false;
            }
            if (ths.requireInfo.defaultAddressFlag === '1') {
                Toast('请选择收货地址');
                return false;
            }

            const orderJsonList = this.orderJsonList;
            // 新疆浩源网点必填
            if (this.showReferralFeature) {
                if (!this.referralOutlet) {
                    Toast('请选择网点');
                    return;
                }

                orderJsonList.every((item) => {
                    item.referralCode = this.referralCode;
                    item.outletId = this.referralOutletId;
                    item.outletName = this.referralOutlet;
                    item.orderItemJsonList.every((item) => {
                        item.referralCode = this.referralCode;
                        item.outletId = this.referralOutletId;
                        item.outletName = this.referralOutlet;
                    });
                });
            }
            const params = {
                deliveryMethodId: '1',
                memberShippingAddressId: ths.requireInfo.defaultAddress.id,
                submitType: ths.submitType,
                couponCode: this.genericCouponCode || -1,
                referralCode: this.referralCode,
                outletId: this.referralOutletId,
                orderJsonList: JSON.stringify(orderJsonList),
                usePointFlag: ths.usePointFlag
            };
            if (this.$route.params.productGroupId || Number(this.$route.params.productGroupId) === 0) {
                params.productGroupId = this.$route.params.productGroupId;
            }
            ths.$doRequest(
                {
                    url: '/order/submitOrder',
                    params: params,
                    before: function () {
                        ths.loading = toastLoading();
                    },
                    complete: function () {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    if (data.responseCode === '100000') {
                        ths.ESVStorage.removeSavedValue('invoiceArr');
                        ths.ESVStorage.removeSavedValue('fullArrText');
                        ths.ESVStorage.removeSavedValue('objCoupon');
                        ths.ESVStorage.removeSavedValue('fullArr');
                        ths.ESVStorage.removeSavedValue('remarkArr');
                        ths.ESVStorage.removeSavedValue('invoiceIndex');
                        ths.ESVStorage.putSavedValue('orderInfo', data.result, () => {
                            const flag = data.result.zeroOrderFlag === 1;

                            if (flag === true) {
                                // ths.esvOpenPage('OPPaysuccess');
                                ths.ESVStorage.putSavedValue('status', '', () => {
                                    ths.esvReloadPage({ name: 'OPMyOrder', query: { status: '' } });
                                });
                            } else {
                                let channelType = 'WECHAT';
                                ths.ESVStorage.getSessionValue('channelType', (data) => {
                                    channelType = data;
                                });
                                if (channelType === 'APP') {
                                    ths.esvOpenPage({
                                        name: 'OPPayorder',
                                        params: {
                                            outletId: ths.referralOutletId
                                        }
                                    });
                                } else {
                                    ths.getIndexUrl();
                                }
                            }
                        });
                    } else {
                        Toast(data.message);
                    }
                }
            );
        },
        // 二次鉴权
        getIndexUrl () {
            this.ESVStorage.putSavedValue('__mall_cache_referralOutletId', this.referralOutletId || '');
            const params = {
                url: '#/OPPayorder?esvOAuthUrlIndex=1'
            };
            this.$doRequest(
                {
                    url: '/oauth/getActualOAuthUrl',
                    params: params
                },
                function (data) {
                    // sessionStorage.setItem('isIndex', '1');
                    window.location.href = data.result;
                    // window.location.href = '/';
                },
                function (error) {
                    Toast(error ? error.message || '服务器响应异常' : '服务器响应异常');
                },
                function (error) {
                    Toast(error ? error.message || '接口请求异常' : '接口请求异常');
                }
            );
        },
        activityClick (item) {
            this.objCoupon.couponName = item.couponName;
            this.objCoupon.couponSimpleName = item.couponSimpleName;
            this.objCoupon.couponCode = item.couponCode;
            this.markData();
            this.confirmOrderNew(this.requireInfo);
        },
        clickRadio (name, item, index) {
            // console.log(name);
            const fullArr = this.fullArr ? this.fullArr : [];
            const fullArrText = this.fullArrText ? this.fullArrText : [];
            if (name.activityType === 2) {
                item.value.fullText = '满' + name.meet + '件减' + name.preferentialAmount + '元';
            } else if (name.activityType === 3) {
                item.value.fullText = '满' + name.meet + '件打' + Number(name.preferentialAmount) / 10 + '折';
            } else {
                item.value.fullText = '不参加活动';
            }
            fullArr[index] = name.activityId;
            // console.log(this);
            this.fullArr[index] = name.activityId;
            fullArrText[index] = item.value.fullText;

            this.ESVStorage.putSavedValue('fullArr', fullArr);
            this.ESVStorage.getSavedValue('fullArr', (data) => {
                // console.log(data[index]);
            });

            this.ESVStorage.putSavedValue('fullArrText', fullArrText);
            this.markData();
            // 切换活动调接口
            this.confirmOrderNew(this.requireInfo, name, index, item);
        },
        confirmOrderNew (item, name, indexNew, itemNew1) {
            const ths = this;
            const params = {
                areaId: item.defaultAddress !== undefined ? item.defaultAddress.areaId : '',
                couponCode: this.genericCouponCode || -1,
                usePointFlag: ths.usePointFlag,
                orderJsonList: JSON.stringify(ths.orderJsonList)
            };
            if (this.$route.params.productGroupId || Number(this.$route.params.productGroupId) === 0) {
                params.productGroupId = this.$route.params.productGroupId;
            }
            ths.$doRequest(
                {
                    url: '/order/confirmOrderNew',
                    params: params,
                    before: function () {
                        ths.loading = toastLoading();
                    },
                    complete: function () {
                        ths.saveLoading = false;
                        clearToastLoading(ths.loading);
                    }
                },
                (data) => {
                    ths.requireInfoall = data.result;

                    console.log(ths.requireInfoall);
                    this.setGenericCouponList(data.result);
                    ths.ESVStorage.putSavedValue('objCoupon', ths.objCoupon);
                    ths.fullshow = false;
                    ths.showstyleActivity = false;
                    ths.orderRespDTOList = [];
                    ths.orderRespDTOList = data.result.orderRespDTOList;

                    ths.couponList = data.result.couponList;

                    // 优惠券
                    if (ths.couponList && ths.couponList.length > 0) {
                        ths.couponList.push({
                            couponName: '不使用优惠券',
                            couponCode: '-1'
                        });
                    }

                    ths.radioActivity = ths.objCoupon.couponCode;
                    ths.couponName = ths.objCoupon.couponName;
                    ths.couponSimpleName = ths.objCoupon.couponSimpleName;

                    // 活动
                    ths.orderRespDTOList.forEach((itemNew, index) => {
                        // 数据回显 后期需要优化
                        itemNew.value = { ...itemNew.value, ...this.deliveryArr[index] };
                        // console.log(typeof itemNew.value.activeList);
                        if (typeof itemNew.value.activeList === 'string') {
                            itemNew.value.activeList = JSON.parse(itemNew.value.activeList);
                            console.log(itemNew.value.activeList);
                        }
                        if (itemNew.value.activeList && itemNew.value.activeList.length > 0) {
                            itemNew.value.activeList.push({
                                activityId: -1,
                                activityTitle: '不参加活动',
                                activityType: 4
                            });
                        }
                        // 赋值活动
                        ths.ESVStorage.getSavedValue('fullArr', (data) => {
                            ths.fullArr = data;
                            if (ths.fullArr) {
                                itemNew.value.fullId = ths.fullArr[index];
                            }
                        });

                        ths.ESVStorage.getSavedValue('fullArrText', (data) => {
                            ths.fullArrText = data;
                            if (ths.fullArrText) {
                                itemNew.value.fullText = ths.fullArrText[index];
                            }
                        });

                        itemNew.invoice = ths.arr[index];
                    });

                    ths.ESVStorage.putSavedValue('requireInfoall', ths.requireInfoall);
                    if (ths.couponList) {
                        for (var i = 0; i < ths.couponList.length; i++) {
                            if (ths.couponList[i].couponCode === ths.objCoupon.couponCode) {
                                ths.radioActivity = ths.objCoupon.couponCode;
                                ths.couponName = ths.objCoupon.couponName;
                                ths.couponSimpleName = ths.objCoupon.couponSimpleName;
                                return false;
                            } else {
                                ths.radioActivity = '-1';
                                ths.couponName = '不使用优惠券';
                            }
                        }
                    }
                }, function (data) {
                    if (data.responseCode === '100120' || data.responseCode === '100123') {
                        // console.log(data.message);
                        Toast(data.message);
                    }
                    if (data.responseCode === '900023') {
                        Toast('请选择收货地址');
                    }
                    const fullArr = ths.fullArr ? ths.fullArr : [];
                    const fullArrText = ths.fullArrText ? ths.fullArrText : [];

                    itemNew1.value.fullText = '不参加活动';
                    itemNew1.value.fullId = -1;
                    fullArr[indexNew] = -1;
                    fullArrText[indexNew] = '不参加活动';
                    // console.log(itemNew1);
                    ths.ESVStorage.putSavedValue('fullArr', fullArr);
                    ths.ESVStorage.putSavedValue('fullArrText', fullArrText);
                }
            );
        },
        markData (type) {
            let arr = [];
            this.orderJsonList = [];
            this.setDeliveryArr({ orderRespDTOList: this.orderRespDTOList });
            try {
                this.orderRespDTOList.forEach((item, index) => {
                    // 处理商品信息
                    try {
                        item.value.memberOrderItemList.forEach((itemNew, index) => {
                            try {
                                if (item.value.deliveryMethodCode === 'COME_ON' && (!item.value.outletId && item.value.outletId !== 0) && type === 'submit') {
                                    throw new Error('请选择自提网点');
                                } else {
                                    arr.push({
                                        productId: itemNew.productId,
                                        skuCode: itemNew.skuCode,
                                        quantity: itemNew.quantity,
                                        spreadingCode: itemNew.spreadingCode,
                                        activityId: item.value.activityId || '-1',
                                        outletId: item.value.outletId || '',
                                        deliveryMethodCode: item.value.deliveryMethodCode
                                    });
                                }
                            } catch (error) {
                                throw error;
                            }
                        });
                    } catch (error) {
                        this.$toast(error.message);
                        throw error;
                    }

                    const currentItem = this.arr[index];

                    if (currentItem && currentItem.invoiceType && currentItem.invoiceType === 0) {
                        this.orderJsonList.push({
                            orderItemJsonList: arr,
                            // participate: ((item.value.activeList && item.value.activeList.length <= 0) || this.fullArr[index] === -1) ? 2 : 1,
                            remark: item.value.remark,
                            activityId: item.value.activityId || '-1'
                        });
                    } else {
                        this.orderJsonList.push({
                            orderItemJsonList: arr,
                            // participate: ((item.value.activeList && item.value.activeList.length <= 0) || this.fullArr[index] === -1) ? 2 : 1,
                            activityId: item.value.activityId || '-1',
                            remark: item.value.remark,
                            invoiceType: currentItem && currentItem.invoiceType ? currentItem.invoiceType : 0,
                            invoiceTitleType: currentItem && currentItem.invoiceTitleType ? currentItem.invoiceTitleType : '',
                            invoiceTitle: currentItem && currentItem.invoiceTitle ? currentItem.invoiceTitle : '',
                            taxNumber: currentItem && currentItem.taxNumber ? currentItem.taxNumber : '',
                            depositBank: currentItem && currentItem.depositBank ? currentItem.depositBank : '',
                            bankAccount: currentItem && currentItem.bankAccount ? currentItem.bankAccount : '',
                            enterpriseAddress: currentItem && currentItem.enterpriseAddress ? currentItem.enterpriseAddress : '',
                            enterprisePhone: currentItem && currentItem.enterprisePhone ? currentItem.enterprisePhone : ''

                        });
                    }

                    arr = [];
                });
            } catch (error) {
                throw error;
            }
        },
        // 活动优惠点击
        openFullShow (indexNew) {
            this.activeList = this.orderRespDTOList[indexNew].value.activeList;
            this.activeList.forEach((item, index) => {
                item.aindex = indexNew;
            });
            this.ESVStorage.getSavedValue('fullArr', (data) => {
                this.fullArr = data;
                this.fullIdNew = this.fullArr[indexNew];
                // console.log(typeof this.fullIdNew);
                // console.log(this.fullIdNew);
            });
            this.fullshow = true;
        },
        closeFullShow () {
            this.fullshow = false;
        },
        openInvoice (index) {
            const remarkArr = [];
            this.orderRespDTOList.forEach((item, index) => {
                remarkArr.push({
                    remark: item.value.remark
                });
            });
            this.ESVStorage.putSavedValue('remarkArr', remarkArr);
            this.ESVStorage.putSavedValue('invoiceIndex', index);
            this.esvOpenPage({
                name: 'OPInvoice', params: { index: index }
            });
        },
        cellClickCheck () {
            this.checked = !this.checked;
        },
        changeChecked (value) {
            if (value) {
                this.usePointFlag = '1';
            } else {
                this.usePointFlag = '2';
            }
            this.ESVStorage.putSavedValue('usePointFlag', this.usePointFlag);
            this.markData();
            this.confirmOrderNew(this.requireInfo);
        }
    },
    computed: {
        ...mapGetters(['deliveryArr']),
        submitShow () {
            // return !focus && this.fullshow === false && this.showstyleActivity === false && this.showstyleCoupons === false && this.requireInfoall && this.requireInfoall.orderAmount;
            return true;
        },
        genericCouponShow () {
            return this.$route.params.productGroupId || this.$route.params.productGroupId === 0;
        },
        showReferralFeature () {
            return this.merchantCode === '0602';
        }
    },
    watch: {
        bodyheight (curVal, oldVal) {
            if (curVal > oldVal) {
                this.focus = false;
            } else {
                this.focus = true;
            }
        }
    },
    components: {
        OpSubmitBar: () => import('@/components/common/opSubmitBar')
    }
};
</script>

<style lang="scss" scoped>
#page_Container {
    height: 100%;
    .page {
        height: 100%;
    }
}
.addrinfo {
    padding: 0 12px 12px 12px;
    background-color: #fff;
    .adddetail {
        font-size: 14px;
        color: #414141;
        .consignee {
            padding-left: 25px;
            line-height: 20px;
            padding-top: 12px;
            .name {
                margin-right: 30px;
            }
        }
        .address {
            margin-top: 5px;
            img {
                width: 14px;
                margin-right: 9px;
                display: inline-block;
                vertical-align: top;
                margin-top: 2px;
            }
            .addrdetail {
                width: 90%;
                display: inline-block;
            }
        }
    }
    .addr {
        background: url('../assets/img/goods/right.png') right center no-repeat;
        background-size: 10px 15px;
        img {
            width: 14px;
            margin-right: 9px;
        }
        .noaddr {
            color: #999;
            font-size: 18px;
            height: 90px;
            line-height: 90px;
        }
    }
}
.afteraddrpng {
    font-size: 0;
    img {
        height: 6px;
        width: 100%;
    }
}
.ordergoods {
    background-color: #fff;
    .goods {
        height: 115px;
        clear: both;
        padding-left: 12px;
        line-height: 16px;

        .goods-img {
            float: left;
            img {
                width: 79px;
                height: 79px;
            }
            margin: 12px 12px 0px 0px;
        }
        .goods-detail {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            height: 94px;
            float: left;
            // width: 210px;
            width: 68%;
            font-size: 12px;
            margin-top: 6px;
            .goodstitle {
                color: #414141;
            }
            .specifications {
                color: #999;
                // margin-top: 3px;
                // margin-bottom: 1px;
                word-break: break-all;
            }
            .goodsprice {
                color: #ee2e50;
                line-height: 20px;
                span {
                    font-size: 14px;
                }
                .num {
                    color: #999;
                    font-size: 12px;
                    float: right;
                }
            }
        }
    }
}

.require {
    color: #414141;
    font-size: 14px;
    padding-left: 12px;
    // height: 50px;
    line-height: 50px;
    background-color: #fff;
    margin-bottom: 1px;
}
.distribution {
    padding: 0 12px;
    background-color: #fff;
    .choose {
        background: url('../assets/img/goods/right.png') right center no-repeat;
        background-size: 10px 15px;
        .f-right {
            float: right;
            padding-right: 15px;
        }
        .toCoupons {
            color: #ee2e50;
            padding: 1px;
            border: 1px solid #ee2e50;
        }
        .toCouponsmark {
            img {
                margin-left: 2px;
                width: 20px;
                height: 20px;
                vertical-align: middle;
            }
        }
    }
    .paratitle {
        text-align: center;
        color: #414141;
        font-size: 16px;
        line-height: 20px;
        margin-top: 22px;
        margin-bottom: 27px;
    }
    .attrs {
        line-height: 20px;
        margin: 26px 12px;
        font-size: 14px;
        overflow-y: scroll;
        height: 200px;
        .attr {
            color: #bebec5;
            vertical-align: top;
        }
        .content {
            margin-left: 46px;
            width: 68%;
            display: inline-block;
            color: #414141;
        }
        p {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #ee2e50;
            letter-spacing: 0;
        }
        span {
            font-size: 12px;
            letter-spacing: 0;
        }
        .deliveryMethodstyle {
            font-size: 14px;
            color: #414141;
        }
        // /deep/ .van-radio{
        //     margin-top:9px;
        // }
    }
    .clickoff {
        width: 327px;
        height: 44px;
        line-height: 44px;
        margin: 0 auto 20px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        border-radius: 22px;
        background-color: $primary-color;
    }
}
.buyermessage {
    .van-cell {
        padding-left: 0;
        // padding-right: 0;
    }
}
/deep/ .van-radio /deep/ .van-icon {
    width: 1.5em;
}
.attrs {
    .van-cell {
        padding-left: 3px;
        padding-right: 3px;
        /deep/ .van-cell__title {
            flex: 6 !important;
        }
        /deep/ .van-cell__value {
            overflow: visible;
            letter-spacing: 0px;
            /deep/ .van-radio {
                overflow: visible;
                letter-spacing: 0px;
                /deep/ .van-radio__input {
                    overflow: visible;
                }
                /deep/ .van-icon {
                    width: 1.5em;
                    letter-spacing: 0px;
                }
            }
        }
        /deep/ .van-cell__label {
            color: #999;
        }
    }
    /deep/ .van-cell .van-cell__title {
        max-width: none !important;
    }
    .van-cell:not(:last-child)::after {
        content: '';
        left: 0;
    }
}

.attrsNew {
    line-height: 20px;
    margin: 26px 0 26px 12px;
    font-size: 14px;
    overflow-y: scroll;
}
.van-submit-bar .van-button {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #ee2e50;
    border-radius: 25px;
    margin-right: 10px;
}
.van-radio {
    float: right;
}
.placehholder {
    content: '';
    height: 50px;
}
.bottomtab {
    padding: 0 10px;
    background: #fff;
    width: 100%;
    bottom: 0;
    position: fixed;
    // display:block;
    // padding: 0 12px;
    // height: 50px;
    // line-height: 50px;
    // background: #fff;
    // position: fixed;
    // bottom: 0;
    // left: 0;
    // width: 100%;
    // .submitBtn  {
    //     .van-submit-bar .van-button {
    //         width: 120px;
    //         height: 40px;
    //         line-height: 40px;
    //         margin-right: 10px;
    //         border-radius: 50px;
    //     }
    // }
}
.spanStyleRight {
    span {
        color: #414141 !important;
    }

    font-size: 14px;
    // float:right;
    // padding-right:12px;
}
.spanStyleRightNew {
    float: right;
    padding-right: 12px;
    font-size: 12px;
    width: 74%;
    text-align: left;
    line-height: 50px;
}
@media screen and (max-width: 320px) {
    .spanStyleRightNew {
        float: right;
        padding-right: 12px;
        font-size: 12px;
        width: 74%;
        text-align: left;
        line-height: 25px;
    }
}
.productStyle {
    background: #fff;
    margin-top: 12px;
    .title {
        padding: 12px;
        overflow: hidden;
        img {
            width: 18px;
            float: left;
            margin-right: 10px;
            margin-top: 2px;
        }
        span {
            float: left;
        }
    }
}
.kdImg {
    margin-top: 3px;
}
.js {
    text-align: right;
    padding: 10px 15px;
    span {
        color: #ee2e50;
    }
}
.yhStyle {
    border: 1px solid #ee2e50;
    padding: 5px;
    color: #ee2e50;
}
.couponSlot {
    float: left;
    .couponDiv1 {
        font-size: 12px;
        width: 70%;
        float: left;
    }
    .couponDiv2 {
        font-size: 12px;
        color: #999;
        width: 70%;
        float: left;
    }
    .couponDivNo {
        font-size: 14px;
    }
}
.iconDiv {
    float: right;
}
.divRight {
    width: 20px;
    height: 25px;
    background: #f2f2f2;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 99;
    opacity: 0;
}
.checkBox {
    position: relative;
    .checkBoxDiv {
        position: absolute;
        right: 0;
        top: 1px;
        width: 20px;
        height: 20px;
    }
}
.checkBoxStyle {
    /deep/ .van-checkbox__icon--round .van-icon {
        border-radius: 10%;
    }
}
</style>
